import type {
    GetCitiesResponseType
} from "./type";
import {
    request
} from "../request";

const getCities = async (): Promise<GetCitiesResponseType> => {
    return await request<GetCitiesResponseType>("/staticData/getCities", {
        method: "GET"
    });
};

export default getCities;
